
import React from 'react';
import Slider from 'slider';
import _HighlightPromotionContainer from './_HighlightPromotionContainer.scss';
import {HighlightBusinesses} from 'api';
import {LoadingPage} from 'components/loading-page';
import {UploadImage} from 'components/UI/Image';
import {Link, withRouter} from 'react-router-dom';

class HighlightBusinessesContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
      // {
      //   link: 'https://phuyentrade.gov.vn/doanh-nghiep/cong-ty-tnhh-thuong-mai-xuat-nhap-khau-quoc-gia',
      //   logo: require('assets/images/businesses/cong-ty-tnhh-thuong-mai-xuat-nhap-khau-quoc-gia.png')
      // },
      // {
      //   link: 'https://phuyentrade.gov.vn/doanh-nghiep/cong-ty-tnhh-sx-and-tm-phi-hung',
      //   logo: require('assets/images/businesses/cong-ty-tnhh-sx-and-tm-phi-hung.png')
      // },{
      //   link: 'https://phuyentrade.gov.vn/doanh-nghiep/cong-ty-co-phan-vinacafe-son-thanh',
      //   logo: require('assets/images/businesses/cong-ty-co-phan-vinacafe-son-thanh.png')
      // }
      ],
      limit: 10
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: 'priority ASC'
      }
    };
    HighlightBusinesses.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    // const settings = {
    //   className: 'slider slick-custom home-slick',
    //   dots: true,
    //   infinite: true,
    //   centerMode: false,
    //   speed: 1000,
    //   autoplaySpeed: 4000,
    //   arrows: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   pauseOnHover: false
    // };
    const settings = {
      className: 'slider variable-width custom-react-slick',
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [{
        breakpoint: 1201,
        settings: {
          slidesToShow: 3
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1
        }
      }]
    };
    return (
      <section className='center highlight-promotion-container'>
        <h2 className='highlight-title'><span>DOANH NGHIỆP&nbsp;TIÊU BIỂU</span></h2>
        <Slider {...settings}>
          {
            this.state.data.map((item, i) => {
              return (
                <div className='hinghlight-item'>
                  <a className='item-link' href={item.link} target="_blank">
                    <UploadImage transform="crop" type="HIGHLIGHT_BUSINESS" width="545" height="300" image={item.banner}/>
                    {/* <img width={545} height={300} src={item.logo}/> */}
                  </a>
                </div>
              );
            })
          }
        </Slider>
      </section>
    );
  }
}

export default withRouter(HighlightBusinessesContainer);



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightBusinessesContainer.jsx